export const numberFormat = (val: number): string => {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Formats values by adding commas as thousand separators
  };
